import { ADVICE_REQUESTS_ENDPOINT } from 'common/constants'
import { AsyncConsumer, request } from 'common/utils'

import query from '../graphql/sendAGBs.graphql'
import { SendAgBsInput, SendAgBsMutation } from '../interfaces/schemaDefinition'

export const sendAGBs: AsyncConsumer<SendAgBsInput> = async variables => {
  await request<SendAgBsMutation>(ADVICE_REQUESTS_ENDPOINT, query, { sendAGBsInput: variables })
}
